import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { array, func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Col } from "reactstrap";
import { Select } from "../../../../components/formik";
import { ButtonWithSpinner } from "../../../../components/common";

import { highRiskCountriesIsLoadingSelector } from "../../selectors";

import { upsertWatchlistEntryValidationSchema } from "../../validation-schemas";

import "./upsertWatchListEntryFormHighRiskCountry.css";

const UpsertWatchListEntryFormHighRiskCountry = ({ handleSubmit, entries }) => {
  const initialValues = {
    countryId: null,
  };
  const formRef = useRef(null);
  const isLoading = useSelector(highRiskCountriesIsLoadingSelector);

  return (
    <div className="">
      <Formik
        ref={formRef}
        enableReinitialize
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={upsertWatchlistEntryValidationSchema}
      >
        <Form className="upsert-watch-list-entry-form">
          <Col md={12} className="p-0">
            <Field
              menuIsOpen={true}
              type="text"
              name="countryId"
              placeholder="Country..."
              component={Select}
              options={entries}
              isClearable
            />
          </Col>
          <Col className="w-100 d-flex justify-content-center pt-3">
            <ButtonWithSpinner
              text="Add"
              onClick={() => formRef.current.submitForm()}
              className="high-risk-countries-add-button"
              loading={isLoading}
            />
          </Col>
        </Form>
      </Formik>
    </div>
  );
};

UpsertWatchListEntryFormHighRiskCountry.propTypes = {
  handleSubmit: func.isRequired,
  entries: array,
};

export default UpsertWatchListEntryFormHighRiskCountry;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/upsert-watch-list-entry-form/UpsertWatchListEntryFormHighRiskCountry.jsx